import * as React from 'react'
//import { Link } from 'gatsby'
//import { StaticImage } from "gatsby-plugin-image"

import Layout from '../components/layout'
import HeroHome from '../components/hero-home'
import FeaturedProducts from '../components/feature-products'
import FeaturedSecondaryProducts from '../components/feature-secondary-products'
import Seo from '../components/seo'
import ContactForm from '../components/contact-form'

const IndexPage = () => {
  console.log('hello index')

  return (
    <Layout>
      <Seo title='Amerex México - Home' />
      <HeroHome />

      <FeaturedProducts />

      {/* about */}
      <div
        id='hero-about'
        className='col-12 col-md-10 hero-div hero-contain justify-content-end mx-auto'
      >
        <div className='hero-info d-flex flex-wrap align-items-center justify-content-center col-md-7 col-12 shadow-sm rounded'>
          <h2 className='fs-1 text-center'>
            Combatiendo el fuego desde más de 20 años
          </h2>
          {/* <p className='lead text-danger text-center'></p> */}
          <p>
            En 1997 iniciamos operaciones y el proyecto que en Junio 6 de 1999,
            se concretaría en la representación y sociedad con el fundador de la
            fábrica AMEREX CORPORATION, Edgar Katterman Paine (Ned Paine) para
            promover la marca AMEREX en el territorio nacional y desde entonces,
            continuamos fomentando la distribución y promoviendo los equipos que
            fabrica AMEREX. En enero 2019, AMEREX INTERNATIONAL es cerrada y el
            control de las operaciones, pasa a la nueva familia -McWANE-
            propietaria de la fabrica y ahora continuamos haciendo negocios, con
            la operadora McWANE INTERNATIONAL.
          </p>
          <p>
            AMEREX CORPORATION es el fabricante más grande en equipos contra
            incendios. Con sede en Trussville, Alabama, Amerex fabrica
            extintores de incendios manuales y con ruedas para entornos
            comerciales e industriales, así como sistemas de vehículos de
            supresión de incendios y para distintos usos específicos, como
            Autobuses o camiones de valores. La tecnología innovadora de AMEREX
            ha llevado a la producción de sistemas de restaurante automáticos
            prediseñados, sistemas de extinción de incendios de vehículos,
            detección de gas, sistemas industriales y dispositivos de detección
            de incendios.
          </p>
          {/* <Link className="btn btn-lg btn-danger" to="/">
            Descargar presentación
          </Link> */}
        </div>
      </div>
      <ContactForm />
      <FeaturedSecondaryProducts />
    </Layout>
  )
}
export default IndexPage
